/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_LedeInputs */

const tr_landing_web_lede = /** @type {(inputs: Landing_Web_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi web mağazanız ShopPanel’e dahil. Sürükle bırak düzenleyiciyle tasarlarsınız, ürünler aynı katalogdan gelir, stok tek yerden düşer. Kendi alan adınız, kendi ödeme ve kargo anlaşmanız.`)
};

const en_landing_web_lede = /** @type {(inputs: Landing_Web_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own web store is part of ShopPanel. You build it by dragging and dropping, products come from the same catalogue, and stock is reduced in one single place. Your own domain, your own payment provider, your own shipping contract.`)
};

const de_landing_web_lede = /** @type {(inputs: Landing_Web_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr eigener Webshop gehört zu ShopPanel. Sie gestalten ihn per Ziehen und Ablegen, die Produkte kommen aus demselben Katalog, der Bestand sinkt an einer einzigen Stelle. Eigene Domain, eigener Zahlungsanbieter, eigener Versandvertrag.`)
};

const ru_landing_web_lede = /** @type {(inputs: Landing_Web_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственный интернет-магазин входит в ShopPanel. Вы собираете его перетаскиванием, товары берутся из того же каталога, а остаток списывается в одном месте. Свой домен, свой платёжный провайдер, свой договор с курьерской службой.`)
};

/**
* | output |
* | --- |
* | "Your own web store is part of ShopPanel. You build it by dragging and dropping, products come from the same catalogue, and stock is reduced in one single pla..." |
*
* @param {Landing_Web_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_lede = /** @type {((inputs?: Landing_Web_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_lede(inputs)
	if (locale === "de") return de_landing_web_lede(inputs)
	if (locale === "ru") return ru_landing_web_lede(inputs)
	return tr_landing_web_lede(inputs)
});